import { navigate } from 'gatsby';
import { useCallback } from 'react';

interface PageControllerParams {
  directions?: [string];
  isFilial?: [boolean | null];
  isPromotion?: [boolean | null];
  category?: string;
  date?: string;
}

export const usePageChanger = ({
  directions,
  isPromotion,
  isFilial,
  category,
  date,
}: PageControllerParams) =>
  useCallback((nextPage: number) => {
    let pagePath = '';

    if (directions?.includes('PremiumUltra')) {
      pagePath = `/premium-ultra`;
    }

    if (isPromotion?.includes(true)) {
      pagePath = `/actions`;
    }

    if (isFilial?.includes(true)) {
      pagePath = `/filial`;
    }

    if (category) {
      pagePath = `/${category}`;
    }

    if (date) {
      pagePath = `/${date}`;
    }

    if (nextPage === 1) {
      pagePath = `${pagePath}/`;
    } else {
      pagePath = `${pagePath}/${nextPage}`;
    }

    return navigate(pagePath);
  }, []);
